import React from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Icon } from '@betterment/samba-react';
import { HR, Heading, ListRowButton } from '@betterment/style-closet-react';

import { CustomerSignupValues } from './Controller';

import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';

export interface CheckingAccountTypeSelectionStepProps extends StepProps<CustomerSignupValues> {
  handleIndividualClick: () => void;
  handleJointClick: () => void;
  handleClose: () => void;
}

const AccountTypeSelection: React.FC<CheckingAccountTypeSelectionStepProps> = ({
  flowState,
  handleIndividualClick,
  handleJointClick,
  handleClose,
}) => {
  const { stepTitle } = flowState.values;

  return (
    <WorkflowLayout
      feature="checking_customer_signup"
      pageTitle="Sign up - Checking"
      workflowTitle={stepTitle}
      onClose={handleClose}
    >
      <Heading variant="primary">Who will use this account?</Heading>
      <HR />
      <ListRowButton
        variant="expanded"
        verticalAlign="top"
        leadingTitle="You (individual account)"
        leadingSubtitle="Only you will have access to this account."
        leadingIcon={<Icon name="Person" size="small" />}
        trailingIcon={<Icon name="CaretRight" size="small" />}
        onPress={() => {
          track('ElementClicked', { name: 'You', flow: 'OpenCheckingAccount' });
          handleIndividualClick();
        }}
      />
      <HR />
      <ListRowButton
        variant="expanded"
        verticalAlign="top"
        leadingTitle="You and someone else (joint account)"
        leadingSubtitle="You'll both have full access to the account and your own Visa&reg; debit cards."
        leadingIcon={<Icon name="People" size="small" />}
        trailingIcon={<Icon name="CaretRight" size="small" />}
        onPress={() => {
          track('ElementClicked', { name: 'YouAndSomeoneElse', flow: 'OpenCheckingAccount' });
          handleJointClick();
        }}
      />
      <HR />
    </WorkflowLayout>
  );
};

export default AccountTypeSelection;
